import templateAssetEdit from './contactAssetEdit.template.html';
import templateLiabilityEdit from './contactLiabilityEdit.template.html';
import templateAssetCommitment from './contactAssetCommitmentScheduleEdit.template.html';
import templateInsuranceEdit from './contactInsuranceEdit.template.html';

/* @ngInject */

export default (
  $q,
  $scope,
  $rootScope,
  $timeout,
  $state,
  $stateParams,
  $filter,
  $mdUtil,
  $mdDialog,
  cookies,
  actionService,
  navigationService,
  lendersService,
  accountsService,
  messagesService,
  Contact,
  contactService,
  contactsService,
  Asset,
  AssetType,
  LabelType,
  Liability,
  LiabilityType,
  Ownership,
  AssetFinanceAssetCommitmentSchedule,
  AssetFinanceAssetCommitment,
  outlookService,
  Insurance,
  partnersService,
  eventService,
  jsonFactory,
  Job,
  JobProgress,
  jobService,
  jobsService,
  jobTypesService,
  Note,
  noteService,
  notesService,
  ticketService,
  ticketsService,
  workflowsService,
  labelsService,
  helperService,
  uiService,
  Color,
  assetsService,
  liabilitiesService,
  insurancesService,
  webpage,
  clipboard,
  assetFinanceService,
  dateTimeService,
  ContactMaritalStatusOption,
  ACCOUNT,
  CONTACT,
  NOTE,
  PARTNER,
  TICKET
) => {
  $scope.Model = {
    addresses: [],
    currentContact: {},
    currentContactOwner: {},
    availableContactMaritalStatusOptions: ContactMaritalStatusOption.available(),
    availableAccounts: [],
    availableContacts: [],
    availablePartners: [],
    availableTickets: [],
    availableWorkflows: [],
    availableNotes: [],
    availableEmails: [],
    filteredNotes: [],
    availableJobs: [],
    importantItems: [],
    availableJobTypes: [],
    availableLabels: [],
    availableContactLabels: [],
    availableNoteLabels: [],
    availableTicketLabels: [],
    availableJobLabels: [],
    availableLendersPerCountry: [],
    availableJobProgresses: JobProgress.available,
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableAssetRealEstateTypes: [],
    availableAssetOtherTypes: [],
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableTileColors: Color.available(),
    list: {
      importants: [],
      notes: [],
      jobs: [],
      isJobCompleted: 'everything'
    },
    financeProfileList: {
      realEstateAssets: [],
      otherAssets: [],
      assetCommitmentSchedules: [],
      liabilities: [],
      insurances: []
    },
    filters: {
      currentNoteType: '',
      currentNoteTypeDisplay: 'Everything',
      currentNoteLabel: '',
      currentNoteLabelDisplay: 'All',
      currentNoteOwner: '',
      currentNoteOwnerDisplay: 'Owner',
      currentFile: 'Everything'
    },
    availableSections: ['contactView', 'financeProfile', 'diversificationOpportunities'],
    availableTileActions: ['email_to_notes'],
    activeSection: 'contactView',
    activeTab: undefined,
    activeTabList: 0,
    otherDateFormat: 'MM/YYYY',
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    isClipboardSupported: clipboard.supported,
    isContactLabelSelected: false,
    notesList: null,
    showMap: false,
    isTicketReady: false,
    isNoteReady: false,
    isJobReady: false,
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Set date localization
   * --------------------------------------------------------------------------------
   */
  $scope.otherFormat = {
    formatDate: (date) => {
      const m = moment(date);
      return m.isValid()
        ? m.tz($rootScope.CurrentTimeZone()).format($scope.Model.otherDateFormat)
        : '';
    }
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadMessages = () => {
    messagesService
      .getAvailable({ type: ['email', 'sms'], isActive: true })
      .then((messages) => {
        if (messages && messages.length) {
          $scope.Model.availableMessages = _.filter(
            messages,
            (m) => _.map(m.type, 'name').indexOf('email') > -1
          );
        }
      });
  };

  const loadLendersDocuments = (idLenders) => {
    const deferred = $q.defer();
    lendersService
      .getDocuments({ idLenders, types: ['LOGO', 'CALCULATOR'] })
      .then((lendersDocuments) => {
        if (lendersDocuments && lendersDocuments.length) {
          $scope.Model.availableLendersDocuments = lendersDocuments;
        }
        deferred.resolve(lendersDocuments);
      });
    return deferred.promise;
  };

  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [helperService.getOrganizationCountry().cca2]
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
        $scope.Model.availableNoteLabels = labels.filter(
          (l) => l.type.name === LabelType.note.name
        );
        $scope.Model.availableTicketLabels = labels.filter(
          (l) => l.type.name === LabelType.ticket.name
        );
        $scope.Model.availableJobLabels = labels.filter(
          (l) => l.type.name === LabelType.job.name
        );
        $scope.Model.isContactLabelSelected = true;
      });
  };

  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadJobs = () => {
    $scope.Model.isJobReady = false;
    $scope.Model.availableJobs = [];
    jobsService
      .getAvailablePerContact({ idContact: $stateParams.id, isActive: true })
      .then((jobs) => {
        if (jobs.length) {
          const iItems = jobs.filter(
            (i) =>
              (i.isPinned ||
                i.isJobOverdue($rootScope.CurrentTimeZone()) ||
                i.isJobDue($rootScope.CurrentTimeZone())) &&
              !i.isCompleted
          );
          if (iItems.length) {
            for (let i = 0; i < iItems.length; i += 1) {
              const iIdx = $scope.findIndexById($scope.Model.importantItems, iItems[i]);
              if (iIdx === -1) {
                $scope.Model.importantItems.push(iItems[i]);
              }
            }
          }
          const importantIds = $scope.Model.importantItems.map((i) => i.id);
          $scope.Model.allJobs = jobs;
          if ($scope.Model.list.isJobCompleted === 'completed') {
            $scope.Model.availableJobs = jobs.filter((j) => j.isCompleted);
          } else if ($scope.Model.list.isJobCompleted === 'uncompleted') {
            $scope.Model.availableJobs = jobs.filter(
              (j) => !j.isCompleted && importantIds.indexOf(j.id) === -1
            );
          } else {
            $scope.Model.availableJobs = jobs.filter((j) => importantIds.indexOf(j.id) === -1);
          }
        }
        $scope.Model.isJobReady = true;
        $scope.Model.showAssignedTo = $rootScope.CurrentAccount.isAdministrator;
      });
  };

  const loadJobTypes = () => {
    jobTypesService.getAvailable({ isActive: true }).then((jobTypes) => {
      $scope.Model.availableJobTypes = jobTypes;
    });
  };

  const loadContact = (idContact) => {
    const deferred = $q.defer();
    contactService.readContact({ id: idContact }).then((contact) => {
      $scope.Model.currentContact = contact;
      $scope.Model.availableContacts.push(contact);
      deferred.resolve(contact);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService
      .getSpecific({ idContacts, isActive: true, fields: CONTACT.FIELDS.WTF_LIST })
      .then((contacts) => {
        $scope.Model.availableContacts = $scope.Model.availableContacts.concat(contacts);
        deferred.resolve(contacts);
      });
    return deferred.promise;
  };

  const loadAccounts = () => {
    const deferred = $q.defer();
    accountsService
      .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST })
      .then((accounts) => {
        $scope.Model.availableAccounts = accounts;
        $scope.Model.currentContactOwner = _.find(
          $scope.Model.availableAccounts,
          (acc) => acc.id === $scope.Model.currentContact.idOwner
        );
        deferred.resolve(accounts);
      });
    return deferred.promise;
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    notesService
      .getAvailablePerContact({ idContact: $scope.Model.currentContact.id, isActive: true })
      .then((notes) => {
        if (notes.length) {
          $scope.Model.allNotes = notes;
          $scope.Model.availableNotes = _.filter(
            notes,
            (n) => !n.isPinned && n?.type?.name !== 'email'
          );
          const availableEmailNotes = _.filter(
            notes,
            (n) => !n.isPinned && n?.type?.name === 'email'
          );
          for (let e = 0; e < availableEmailNotes.length; e += 1) {
            const eIdx = $scope.findIndexById(
              $scope.Model.availableEmails,
              availableEmailNotes[e]
            );
            if (eIdx === -1) {
              $scope.Model.availableEmails.push(availableEmailNotes[e]);
            }
          }

          const iItems = notes.filter((n) => n.isPinned);
          for (let i = 0; i < iItems.length; i += 1) {
            const iIdx = $scope.findIndexById($scope.Model.importantItems, iItems[i]);
            if (iIdx === -1) {
              $scope.Model.importantItems.push(iItems[i]);
            }
          }
          $scope.Model.filteredNotes = notes;
        }
        $scope.Model.isNoteReady = true;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadEmails = () => {
    if (!$scope.Model.currentContact.getEmail()) {
      return;
    }

    if (outlookService.isEnabled($scope.Model.currentContactOwner)) {
      outlookService
        .getAvailablePerContact({
          idContact: $scope.Model.currentContact.id,
          idOwner: $scope.Model.currentContact.idOwner,
          contactEmail: $scope.Model.currentContact.getEmail()
        })
        .then((emails) => {
          if (emails.length) {
            $scope.Model.availableEmails = $scope.Model.availableEmails.concat(emails);
          }
        });
    }
  };

  const loadTickets = (idContact) => {
    const deferred = $q.defer();
    ticketsService
      .getByContact({ idContact, isActive: true, fields: TICKET.FIELDS.BOARD })
      .then((tickets) => {
        $scope.Model.availableTickets = tickets;
        $scope.Model.availableCurrentTickets = _.orderBy(
          tickets.filter(
            (t) => t.isActive && !t.isWon && !t.isLost && !t.isFrozen && !t.isSettled
          ),
          'timeStamp',
          'desc'
        );
        $scope.Model.availableCompletedTickets = _.orderBy(
          tickets.filter(
            (t) => t.isActive && (t.isWon || t.isFrozen || t.isSettled || t.isLost)
          ),
          'timeStamp',
          'desc'
        );
        deferred.resolve(tickets);
      });
    return deferred.promise;
  };

  const loadWorkflows = (idWorkflows) => {
    const deferred = $q.defer();
    workflowsService.getSpecific({ idWorkflows, isActive: true }).then((workflows) => {
      $scope.Model.availableWorkflows = workflows;
      deferred.resolve(workflows);
    });
    return deferred.promise;
  };

  const initialize = () => {
    loadMessages();
    loadLabels();
    loadJobs();
    loadJobTypes();
    loadLendersPerCountry().then(() => {
      let idLenders = [];
      if ($scope.Model.availableLendersPerCountry.length) {
        idLenders = _.map($scope.Model.availableLendersPerCountry, 'id');
      }
      loadLendersDocuments(idLenders).then(() => {
        loadCountries().then(() => {
          loadContact($stateParams.id).then(() => {
            webpage.pageTitle(`Contact ${$scope.Model.currentContact.getName()}`);
            $scope.getAssetTypes();
            $scope.getLiabilityTypes();
            $scope.getInsuranceTypes();
            loadAccounts().then(() => {
              loadNotes();
              loadEmails();
            });
            $scope.Model.addresses = [
              $scope.Model.currentContact.person.contact.settlementAddress
            ];

            if (
              $scope.Model.currentContact.person.information.idSpouse &&
              $scope.Model.currentContact.person.information.idSpouse !== ''
            ) {
              loadContacts($scope.Model.currentContact.person.information.idSpouse).then(() => {
                $scope.Model.isReady = true;
              });
            } else {
              $scope.Model.isReady = true;
            }
          });
          loadTickets($stateParams.id).then(() => {
            const idWorkflows = _.uniq(
              _.compact(_.flatten(_.map($scope.Model.availableTickets, 'idWorkflow')))
            );
            loadWorkflows(idWorkflows).then(() => {
              $scope.Model.isTicketReady = true;
            });
          });
        });
      });
    });
  };

  initialize();

  /*
   * Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    $scope.Model.activeSection = section;
  };

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.canMakeCall = () =>
    !!(
      $rootScope.CurrentOrganization.canUsePhone() &&
      $rootScope.CurrentOrganization.hasCommsPhonesInStock() &&
      $rootScope.CurrentOrganization.getPhonesForOwner($rootScope.CurrentAccount.id).length
    );

  $scope.canSendSms = () =>
    !!(!!$rootScope.CurrentOrganization.canUseSMS() && $rootScope.CurrentAccount.getPhone());

  $scope.copyToClipboard = (data) => {
    clipboard.copyText(data);
    uiService.toast({
      text: {
        p1: data.includes('@') ? 'E-Mail' : 'Phone',
        p2: data.includes('@') ? 'address' : 'number',
        p3: 'copied to clipboard'
      }
    });
  };

  $scope.toggleTab = (tab, activeTab) => {
    $scope.Model.activeTab = activeTab === tab ? undefined : tab;
  };

  $scope.cancelledAdding = () => {
    $scope.Model.activeTab = undefined;
  };

  $scope.toggleTabList = (tab) => {
    $scope.Model.activeTabList = tab;
  };

  $scope.toggleContactSummaryContent = () => {
    if ($scope.Model.showMap && $scope.Model.showContactSummary) {
      $scope.Model.showMap = false;
    }
    $scope.Model.showContactSummary = !$scope.Model.showContactSummary;
  };

  $scope.isTicketEditAllowed = () =>
    $rootScope.CurrentAccount.isAdministrator ||
    $rootScope.CurrentOrganization.permissions.usersCanEditDeals;

  $scope.boardHasChanges = () => {
    ticketsService.clearCache();
  };

  $scope.findIndexById = (arr, obj) => arr.findIndex((o) => o.id === obj.id);

  $scope.getSpouse = () => {
    let spouse;
    if (
      $scope.Model.availableContacts.length &&
      $scope.Model.currentContact.person.information.idSpouse &&
      $scope.Model.currentContact.person.information.idSpouse !== ''
    ) {
      spouse = $scope.Model.availableContacts.find(
        (c) => c.id === $scope.Model.currentContact.person.information.idSpouse
      );
    }
    return spouse;
  };

  /*
   * Get Account, Workflow, Contact and Label
   * --------------------------------------------------------------------------------
   */
  $scope.getAccount = (idAccount) =>
    $scope.Model.availableAccounts.find((a) => a.id === idAccount);
  $scope.getWorkflow = (idWorkflow) =>
    $scope.Model.availableWorkflows.find((w) => w.id === idWorkflow);
  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);
  $scope.getLabel = (idLabel) => $scope.Model.availableLabels.find((l) => l.id === idLabel);

  /*
   * Toggle Marketing opt-in
   * --------------------------------------------------------------------------------
   */
  $scope.marketingToggle = () => {
    eventService.confirmDialog({
      event: null,
      alert: {
        messages: [
          'Marketing opt-in option will be permanently changed to "off" and can no longer be changed.'
        ],
        icon: 'error',
        type: 'warning',
        isShowing: true
      },
      organizationName: $rootScope.CurrentOrganization?.organization?.name || '-'
    });
  };

  $scope.marketingToggled = (status) => {
    if (status) {
      $scope.saveContact({
        isMarketing: $scope.Model.currentContact.isMarketing,
        isUpdatesAndReminders: $scope.Model.currentContact.isUpdatesAndReminders
      });
    } else {
      $scope.Model.currentContact.isMarketing = true;
    }
  };

  /*
   * Change Contact Owner
   * --------------------------------------------------------------------------------
   */
  $scope.contactOwnerChange = $mdUtil.debounce(($event, idAccount) => {
    $event.stopPropagation();
    $scope.Model.currentContact.idOwner = idAccount;
    $scope.Model.currentContactOwner = _.find(
      $scope.Model.availableAccounts,
      (acc) => acc.id === $scope.Model.currentContact.idOwner
    );
    $scope.saveContact({
      idOwner: idAccount
    });
  }, 1500);

  /*
   * Show Location
   * --------------------------------------------------------------------------------
   */
  $scope.showLocation = () => {
    $scope.Model.showMap = !$scope.Model.showMap;
    $scope.toggleContactSummaryContent();
  };

  /*
   * Labels
   * --------------------------------------------------------------------------------
   */
  $scope.contactLabelsSelect = ($event, contact) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableContactLabels,
      selectedLabels: contact.idLabels,
      data: contact
    });
  };

  /*
   * Toggle sidebar
   * --------------------------------------------------------------------------------
   */
  $scope.toggleUpdatesAndReminders = $mdUtil.debounce(() => {
    $scope.saveContact({
      isUpdatesAndReminders: $scope.Model.currentContact.isUpdatesAndReminders
    });
  }, 1500);

  /*
   * List connect events
   * --------------------------------------------------------------------------------
   */
  $scope.openConnectCall = (contact) => {
    eventService.connectCall({ contact });
  };
  $scope.openConnectSms = (contact) => {
    eventService.connectSms({ contact });
  };

  /*
   * Send email
   * --------------------------------------------------------------------------------
   */
  $scope.emailSend = ({ event }) => {
    event.stopPropagation();
    eventService.emailSend({
      event,
      accounts: [$rootScope.CurrentAccount],
      messages: $scope.Model.availableMessages,
      contact: $scope.Model.currentContact
    });
  };

  $scope.emailSent = (data) => {
    notesService.clearCache();
    if (data?.status) {
      loadNotes().then(() => {
        $scope.toggleTabList(1, $scope.Model.activeTabList);
      });
    }
    uiService.toast({
      text: {
        p1: 'E-mail',
        p2: data?.subject,
        p3: data?.status ? 'has been sent' : 'could not be sent'
      },
      warn: !data.status
    });
  };

  /*
   * Important list actions
   * --------------------------------------------------------------------------------
   */
  $scope.importantItemPin = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.notePin($event, item);
    }
  };
  $scope.importantItemToggle = (item) => {
    if (item.docType.name === '__datum_job') {
      $scope.jobToggle(item);
    }
  };
  $scope.importantLabelsSelect = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteLabelsSelect($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobLabelsSelect($event, item);
    }
  };
  $scope.importantItemEdit = ($event, item) => {
    $event.stopPropagation();
    if (item.docType.name === '__datum_note') {
      $scope.noteEdit($event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobEdit($event, item);
    }
  };
  $scope.importantItemDelete = (event, item) => {
    if (item.docType.name === '__datum_note') {
      $scope.noteDelete(event, item);
    } else if (item.docType.name === '__datum_job') {
      $scope.jobDelete(event, item);
    }
  };
  $scope.listImportantItemsReady = (list) => {
    $scope.Model.list.importants = list;
  };

  /*
   * Label(s) selected
   * --------------------------------------------------------------------------------
   */
  $scope.labelsSelected = $mdUtil.debounce((selectedLabels, d) => {
    const data = d;
    if (data.docType.name === '__datum_contact') {
      $scope.Model.isContactLabelSelected = false;
      $scope.Model.currentContact.idLabels = selectedLabels;
      $timeout(() => {
        $scope.Model.isContactLabelSelected = true;
      });
      $scope.saveContact({
        idLabels: selectedLabels
      });
    } else if (data.docType.name === '__datum_note') {
      data.idLabels = selectedLabels;
      notesService.clearCache();
      noteService.updateNote(data);
    } else if (data.docType.name === '__datum_job') {
      data.idLabels = selectedLabels;
      $scope.Model.list.jobs.setDataReplace(data);
      jobsService.clearCache();
      jobService.updateJob(data);
    }
  }, 1000);

  /*
   * Job events
   * --------------------------------------------------------------------------------
   */
  $scope.jobTicketAdd = ($event, job, ticket) => {
    eventService.jobEdit({
      event: $event,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: true,
      isTasksPage: false,
      stage: null,
      jobTypes: $scope.Model.availableJobTypes,
      accounts: $scope.Model.availableAccounts,
      workflow: $scope.Model.availableWorkflows,
      ticket
    });
  };

  $scope.jobEdit = ($event, job) => {
    eventService.jobEdit({
      event: $event,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: false,
      isTasksPage: false,
      stage: null,
      jobTypes: $scope.Model.availableJobTypes,
      accounts: $scope.Model.availableAccounts,
      contact: $scope.Model.currentContact
    });
  };

  $scope.jobEdited = (jobData) => {
    jobsService.clearCache();
    const job = jobData;
    const iIdx = $scope.findIndexById($scope.Model.importantItems, job);
    const jIdx = $scope.findIndexById($scope.Model.availableJobs, job);
    if (job.isNew) {
      $scope.Model.availableJobs.push(job);
      if ($scope.Model.activeTabList === 1) {
        $scope.Model.list.jobs.setDataAppend(job);
      }
      delete job.isNew;
      $scope.Model.activeTab = undefined;
    } else if (
      job.isJobOverdue($rootScope.CurrentTimeZone()) ||
      job.isJobDue($rootScope.CurrentTimeZone()) ||
      job.isPinned
    ) {
      if (iIdx === -1) {
        $scope.Model.importantItems.push(job);
      } else {
        $scope.Model.importantItems.splice(iIdx, 1);
        $scope.Model.importantItems.splice(iIdx, 0, job);
      }
      if ($scope.Model.activeTabList !== 1 && jIdx > -1) {
        $scope.Model.availableJobs.splice(jIdx, 1);
      }
      if ($scope.Model.activeTabList === 1) {
        $scope.Model.list.jobs.removeData(job);
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
        if ($scope.Model.activeTabList !== 1) {
          $scope.Model.availableJobs.push(job);
        }
      }
      if ($scope.Model.activeTabList !== 1 && jIdx > -1) {
        $scope.Model.availableJobs.splice(jIdx, 1);
        $scope.Model.availableJobs.splice(jIdx, 0, job);
      }
      if ($scope.Model.activeTabList === 1) {
        if (jIdx > -1) {
          $scope.Model.list.jobs.setDataReplace(job);
        } else {
          $scope.Model.list.jobs.setDataAppend(job);
        }
      }
    }
    if (job.isCompleted) {
      $timeout(() => {
        if (
          job.isJobOverdue($rootScope.CurrentTimeZone()) ||
          job.isJobDue($rootScope.CurrentTimeZone()) ||
          job.isPinned
        ) {
          if (iIdx > -1) {
            $scope.Model.importantItems.splice(iIdx, 1);
          }
        } else {
          if ($scope.Model.activeTabList !== 1 && jIdx > -1) {
            $scope.Model.availableJobs.splice(jIdx, 1);
          }
          if ($scope.Model.activeTabList === 1) {
            $scope.Model.list.jobs.removeData(job);
          }
        }
        $scope.Model.isJobReady = false;
        loadJobs();
      }, 5000);
    }
  };

  $scope.jobDelete = ($event, data) => {
    $event.stopPropagation();
    jobsService.clearCache();
    const selectedJobs = data ? [data] : $scope.Model.list.attachments.getSelected();
    const deleteTimeout = $timeout(() => {
      for (let j = 0; j < selectedJobs.length; j += 1) {
        const iIdx = $scope.findIndexById($scope.Model.importantItems, selectedJobs[j]);
        const jIdx = $scope.findIndexById($scope.Model.availableJobs, selectedJobs[j]);

        if (iIdx > -1) {
          $scope.Model.importantItems.splice(iIdx, 1);
          if ($scope.Model.activeTabList !== 1) {
            $scope.Model.availableJobs.splice(jIdx, 1);
          }
        }
        if ($scope.Model.activeTabList !== 1 && jIdx > -1) {
          $scope.Model.availableJobs.splice(jIdx, 1);
        }
        if ($scope.Model.activeTabList === 1 && jIdx > -1) {
          $scope.Model.list.jobs.removeData(selectedJobs[j]);
        }
        jobService.deleteJob({ id: selectedJobs[j].id });
      }
      $timeout(() => {
        $scope.Model.list.hasJobSelection = false;
        if ($scope.Model.activeTabList === 1) {
          $scope.Model.list.jobs.deselectedData($scope.Model.list.jobs.getSelected());
        }
        loadJobs();
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: selectedJobs.length.formatWithoutCurrency(),
          p2: 'selected task(s) will be',
          p3: 'deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: selectedJobs.length.formatWithoutCurrency(),
              p2: 'selected task(s) deletion',
              p3: 'undone'
            }
          });
          $scope.Model.list.hasJobSelection = false;
          $scope.Model.list.attachments.deselectedData(
            $scope.Model.list.attachments.getSelected()
          );
        }
      });
  };

  $scope.jobDuplicate = () => {
    jobsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.list.jobs.getSelected(),
      jobService.readJob,
      jobService.createJob,
      $scope.Model.list.jobs.setDataAppend,
      'name',
      ' copy',
      'job(s)'
    );
  };

  $scope.jobComplete = () => {
    $scope.jobToggle($scope.Model.list.jobs.getSelected());
  };

  $scope.jobUncomplete = () => {
    $scope.jobToggle($scope.Model.list.jobs.getSelected());
  };

  $scope.jobToggle = (jobs) => {
    jobsService.clearCache();
    const selectedJobs = jobs instanceof Array ? jobs : [jobs];
    for (let j = 0; j < selectedJobs.length; j += 1) {
      const selectedJob = selectedJobs[j];
      selectedJob.isCompleted = !selectedJob.isCompleted;
      jobService.updateJob({
        id: selectedJob.id,
        isCompleted: selectedJob.isCompleted,
        jobProgress: selectedJob.isCompleted
          ? $scope.Model.availableJobProgresses[2]
          : $scope.Model.availableJobProgresses[0]
      });
      const iIdx = $scope.findIndexById($scope.Model.importantItems, selectedJob);
      const nIdx = $scope.findIndexById($scope.Model.availableJobs, selectedJob);
      if (
        selectedJob.isJobOverdue($rootScope.CurrentTimeZone()) ||
        selectedJob.isJobDue($rootScope.CurrentTimeZone()) ||
        selectedJob.isPinned
      ) {
        if (iIdx === -1) {
          $scope.Model.importantItems.push(selectedJob);
        } else {
          $scope.Model.importantItems.splice(iIdx, 1);
        }
        if ($scope.Model.activeTabList !== 1 && nIdx > -1) {
          $scope.Model.availableJobs.splice(nIdx, 1);
        }
        if ($scope.Model.activeTabList === 1) {
          $scope.Model.list.jobs.removeData(selectedJob);
        }
      } else {
        if (iIdx > -1) {
          $scope.Model.importantItems.splice(iIdx, 1);
          if ($scope.Model.activeTabList !== 1) {
            $scope.Model.availableJobs.push(selectedJob);
          }
        }
        if ($scope.Model.activeTabList !== 1 && nIdx > -1) {
          $scope.Model.availableJobs.splice(nIdx, 1);
          $scope.Model.availableJobs.splice(nIdx, 0, selectedJob);
        }
        if ($scope.Model.activeTabList === 1) {
          if (nIdx > -1) {
            $scope.Model.list.jobs.setDataReplace(selectedJob);
          } else {
            $scope.Model.list.jobs.setDataAppend(selectedJob);
          }
        }
      }
      $scope.Model.isJobReady = false;
      loadJobs();
    }
  };

  $scope.jobLabelsSelect = ($event, job) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableJobLabels,
      selectedLabels: job.idLabels,
      data: job
    });
  };

  $scope.listJobChange = (list, data, isSelected) => {
    $scope.Model.list.hasJobSelection = isSelected || list.isSelectedAny();
  };
  $scope.listJobReady = (list) => {
    $scope.Model.list.jobs = list;
  };

  $scope.toggleJobsList = (isJobCompleted) => {
    $scope.Model.list.isJobCompleted = isJobCompleted;
    jobsService.clearCache();
    loadJobs();
  };

  /*
   * Note events
   * --------------------------------------------------------------------------------
   */
  $scope.noteTicketAdd = ($event, note, ticket) => {
    eventService.noteEdit({
      event: $event,
      note,
      list: null,
      url: NOTE.API.UPLOAD,
      ticket,
      title: 'Drag & Drop file(s) here, or click to browse',
      allowedMimeTypes: '',
      allowedExtensions: ''
    });
  };

  $scope.noteEdit = ($event, note) => {
    eventService.noteEdit({
      event: $event,
      note,
      list: $scope.Model.list.notes,
      url: NOTE.API.UPLOAD,
      contact: $scope.Model.currentContact,
      title: 'Drag & Drop file(s) here, or click to browse',
      allowedMimeTypes: '',
      allowedExtensions: ''
    });
  };

  $scope.noteEdited = (noteData) => {
    notesService.clearCache();
    const note = noteData;
    const iIdx = $scope.findIndexById($scope.Model.importantItems, note);
    const nIdx = $scope.findIndexById($scope.Model.availableNotes, note);

    if (note.isNew) {
      if (note.isPinned) {
        if (iIdx === -1) {
          $scope.Model.importantItems.push(note);
        }
      } else {
        if ($scope.Model.activeTabList === 0) {
          $scope.Model.list.notes.setDataAppend(note);
        }
        if ($scope.Model.activeTabList !== 0) {
          $scope.Model.availableNotes.push(note);
        }
      }
      delete note.isNew;
      $scope.Model.activeTab = undefined;
    } else if (note.isPinned) {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
        $scope.Model.importantItems.splice(iIdx, 0, note);
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList === 0) {
        if (nIdx === -1) {
          $scope.Model.list.notes.setDataAppend(note);
        } else {
          $scope.Model.list.notes.setDataReplace(note);
        }
      }
      if ($scope.Model.activeTabList !== 0 && nIdx > -1) {
        $scope.Model.availableNotes.splice(nIdx, 1);
        $scope.Model.availableNotes.splice(nIdx, 0, note);
      }
    }
  };

  $scope.noteDelete = ($event, note) => {
    $event.stopPropagation();
    const section = $scope.Model.activeTabList === 0 ? 'Note' : 'Email';
    const deleteTimeout = $timeout(() => {
      notesService.clearCache();
      const iIdx = $scope.findIndexById($scope.Model.importantItems, note);
      const nIdx = $scope.findIndexById($scope.Model.availableNotes, note);
      const eIdx = $scope.findIndexById($scope.Model.availableEmails, note);

      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList === 0 && nIdx > -1) {
        $scope.Model.list.notes.removeData(note);
      }
      if ($scope.Model.activeTabList !== 0 && nIdx > -1) {
        $scope.Model.availableNotes.splice(nIdx, 1);
      }

      if ($scope.Model.activeTabList === 1 && eIdx > -1) {
        $scope.Model.list.notes.removeData(note);
      }
      if ($scope.Model.activeTabList !== 1 && eIdx > -1) {
        $scope.Model.availableEmails.splice(nIdx, 1);
      }
      noteService.deleteNote({ id: note.id });
      uiService.toast({
        text: {
          p1: section,
          p2: note.getExcerpt(),
          p3: 'has been deleted'
        }
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: section,
          p2: note.getExcerpt(),
          p3: 'will be deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: section,
              p2: note.getExcerpt(),
              p3: 'deletion has been undone'
            }
          });
        }
      });
  };

  $scope.notePin = ($event, noteData) => {
    $event.stopPropagation();
    const note = noteData;
    notesService.clearCache();
    note.isPinned = !note.isPinned;
    noteService.updateNote(note);
    const iIdx = $scope.findIndexById($scope.Model.importantItems, note);
    const nIdx = $scope.findIndexById($scope.Model.availableNotes, note);

    if (note.isPinned) {
      if (iIdx === -1) {
        $scope.Model.importantItems.push(note);
        if ($scope.Model.activeTabList === 0) {
          $scope.Model.list.notes.removeData(note);
        }
      }
      if ($scope.Model.activeTabList !== 0 && nIdx > -1) {
        $scope.Model.availableNotes.splice(nIdx, 1);
      }
    } else {
      if (iIdx > -1) {
        $scope.Model.importantItems.splice(iIdx, 1);
      }
      if ($scope.Model.activeTabList !== 0 && nIdx === -1) {
        $scope.Model.availableNotes.push(note);
      }
      if ($scope.Model.activeTabList === 0) {
        $scope.Model.list.notes.setDataAppend(note);
      }
    }
  };

  $scope.noteLabelsSelect = ($event, note) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableNoteLabels,
      selectedLabels: note.idLabels,
      data: note
    });
  };

  $scope.listNoteReady = (list) => {
    $scope.Model.list.notes = list;
  };

  $scope.notesFilter = ($event, type, label, owner) => {
    $event.stopPropagation();
    if (type !== '' && label !== '' && owner !== '') {
      $scope.Model.filters.currentNoteType =
        type === null ? $scope.Model.filters.currentNoteType : type;
      $scope.Model.filters.currentNoteLabel =
        label === null ? $scope.Model.filters.currentNoteLabel : label;
      $scope.Model.filters.currentNoteOwner =
        owner === null ? $scope.Model.filters.currentNoteOwner : owner;
      $scope.Model.filters.currentNoteTypeDisplay =
        $scope.Model.filters.currentNoteType !== '' &&
        $scope.Model.filters.currentNoteType !== null
          ? $scope.Model.filters.currentNoteType.capitalizeFirstLetter()
          : 'Everything';
      $scope.Model.filters.currentNoteLabelDisplay =
        $scope.Model.filters.currentNoteLabel !== '' &&
        $scope.Model.filters.currentNoteLabel !== null
          ? $scope
              .getLabel($scope.Model.filters.currentNoteLabel)
              .getName()
              .capitalizeFirstLetter()
          : 'All';
      $scope.Model.filters.currentNoteOwnerDisplay =
        $scope.Model.filters.currentNoteOwner !== '' &&
        $scope.Model.filters.currentNoteOwner !== null
          ? $scope.Model.filters.currentNoteOwner.capitalizeFirstLetter()
          : 'Owner';
      $scope.Model.availableNotes = $filter('stNotesFilter')(
        $scope.Model.filteredNotes,
        $scope.Model.filters.currentNoteType,
        $scope.Model.filters.currentNoteLabel,
        $scope.Model.filters.currentNoteOwner
      );
      $scope.Model.list.notes.setData($scope.Model.availableNotes);
    } else {
      $scope.Model.filters.currentNoteType = '';
      $scope.Model.filters.currentNoteLabel = '';
      $scope.Model.filters.currentNoteOwner = '';
      $scope.Model.filters.currentNoteTypeDisplay = 'Everything';
      $scope.Model.filters.currentNoteLabelDisplay = 'All';
      $scope.Model.filters.currentNoteOwnerDisplay = 'Owner';
      $scope.Model.availableNotes = $filter('stNotesFilter')(
        $scope.Model.filteredNotes,
        $scope.Model.filters.currentNoteType,
        $scope.Model.filters.currentNoteLabel,
        $scope.Model.filters.currentNoteOwner
      );
      $scope.Model.list.notes.setData($scope.Model.availableNotes);
    }
  };

  /*
   * Ticket labels events
   * --------------------------------------------------------------------------------
   */
  $scope.ticketLabelsSelect = ($event, ticket) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableTicketLabels,
      selectedLabels: ticket.idLabels,
      data: ticket
    });
  };
  $scope.ticketLabelsSelected = (selectedLabels, data) => {
    const ticket = data;
    ticket.idLabels = selectedLabels;
    ticketsService.clearCache();
    ticketService.updateTicket({ id: data.id, idLabels: data.idLabels });
    if ($scope.Model.activeTabList === 3) {
      const idx = _.findIndex(
        $scope.Model.availableCurrentTickets || [],
        (t) => t?.id === ticket?.id
      );
      if (idx > -1) {
        $scope.Model.availableCurrentTickets.splice(idx, 1, ticket);
      }
    }
    if ($scope.Model.activeTabList === 4) {
      const idx = _.findIndex(
        $scope.Model.availableCompletedTickets || [],
        (t) => t?.id === ticket?.id
      );
      if (idx > -1) {
        $scope.Model.availableCompletedTickets.splice(idx, 1, ticket);
      }
    }
  };

  /*
   * Contact assets
   * --------------------------------------------------------------------------------
   */
  $scope.getAssetTypes = () => {
    if ($scope.Model.availableAssetTypes && $scope.Model.availableAssetTypes.length) {
      $scope.Model.availableAssetRealEstateTypes = $scope.Model.availableAssetTypes.filter(
        (a, idx) => idx === 0 || idx === 1
      );
      $scope.Model.availableAssetOtherTypes = $scope.Model.availableAssetTypes.filter(
        (a, idx) => idx !== 0 && idx !== 1
      );
    }
    $scope.setAssets();
  };

  $scope.setAssets = () => {
    $scope.Model.realEstateAssets = [];
    $scope.Model.otherAssets = [];
    if ($scope.Model.currentContact.assets && $scope.Model.currentContact.assets.length) {
      $scope.Model.realEstateAssets = $scope.Model.currentContact.assets.filter(
        (a) =>
          a.assetType.id === $scope.Model.availableAssetTypes[0].id ||
          a.assetType.id === $scope.Model.availableAssetTypes[1].id
      );
      $scope.Model.otherAssets = $scope.Model.currentContact.assets.filter(
        (a) =>
          a.assetType.id !== $scope.Model.availableAssetTypes[0].id &&
          a.assetType.id !== $scope.Model.availableAssetTypes[1].id
      );
    }
  };

  $scope.assetEdit = ($event, assetType, currentAsset) => {
    $event.stopPropagation();
    const ownership = [Ownership.blank($scope.Model.currentContact.id, 100)];
    const asset = currentAsset ? Asset.build(currentAsset) : Asset.blank(assetType, ownership);
    const isEdit = currentAsset !== undefined;

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          contact: $scope.Model.currentContact,
          countries: $scope.Model.countries,
          lenders: $scope.Model.availableLendersPerCountry
        },
        template: templateAssetEdit,
        controllerAs: '$ctrl',
        controller(contact, countries, lenders) {
          const ctrl = this;
          ctrl.asset = asset;
          ctrl.isEdit = isEdit;

          ctrl.contact = contact;
          ctrl.countries = countries;
          ctrl.lenders = lenders;

          ctrl.confirm = () => {
            $mdDialog.hide({ isEdit: ctrl.isEdit, asset: ctrl.asset });
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        if (result.isEdit) {
          const idx = $scope.Model.currentContact.assets.findIndex(
            (a) => a.id === result.asset.id
          );
          if (idx > -1) {
            $scope.Model.currentContact.assets.splice(idx, 1);
            $scope.Model.currentContact.assets.splice(idx, 0, result.asset);
          }
        } else {
          $scope.Model.currentContact.assets.push(result.asset);
        }
        $scope.setAssets();
        $scope.getLiabilityTypes();
        $scope.getInsuranceTypes();
        $scope.saveAssets();
      });
  };

  $scope.assetDelete = ($event, asset) => {
    $event.stopPropagation();
    helperService
      .deleteItem($scope.Model.currentContact.assets, asset, 'Asset', asset.getName())
      .then((result) => {
        if (result) {
          if (helperService.isAssetTypeOwnerOccupiedOrInvestment(asset.assetType)) {
            $scope.Model.financeProfileList.realEstateAssets.removeData(asset);
          } else {
            $scope.Model.financeProfileList.otherAssets.removeData(asset);
          }
          $scope.saveAssets();
        }
      });
  };

  $scope.listRealEstateAssetsReady = (list) => {
    $scope.Model.financeProfileList.realEstateAssets = list;
  };

  $scope.listOtherAssetsReady = (list) => {
    $scope.Model.financeProfileList.otherAssets = list;
  };

  $scope.saveAssets = $mdUtil.debounce(() => {
    $scope.saveContact({ assets: $scope.Model.currentContact.assets });
  }, 1500);

  /*
   * Contact liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentContact.assets
    );
  };

  $scope.liabilityEdit = ($event, liabilityType, currentLiability) => {
    $event.stopPropagation();
    const ownership = [Ownership.blank($scope.Model.currentContact.id, 100)];
    const liability = currentLiability
      ? Liability.build(currentLiability)
      : Liability.blank(liabilityType, ownership);
    const isEditing = currentLiability !== undefined;

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          contact: $scope.Model.currentContact,
          lenders: $scope.Model.availableLendersPerCountry
        },
        template: templateLiabilityEdit,
        controllerAs: '$ctrl',
        controller(contact, lenders) {
          const ctrl = this;
          ctrl.liability = liability;
          ctrl.isEditing = isEditing;
          ctrl.contact = contact;
          ctrl.lenders = lenders;

          ctrl.confirm = () => {
            $mdDialog.hide({ isEditing: ctrl.isEditing, liability: ctrl.liability });
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        if (result.isEditing) {
          const idx = $scope.Model.currentContact.liabilities.findIndex(
            (a) => a.id === result.liability.id
          );
          if (idx > -1) {
            $scope.Model.currentContact.liabilities.splice(idx, 1);
            $scope.Model.currentContact.liabilities.splice(idx, 0, result.liability);
          }
        } else {
          $scope.Model.currentContact.liabilities.push(result.liability);
        }
        $scope.saveLiabilities();
      });
  };

  $scope.liabilityDelete = ($event, liability) => {
    $event.stopPropagation();
    helperService
      .deleteItem(
        $scope.Model.currentContact.liabilities,
        liability,
        'Liability',
        liability.getName()
      )
      .then((result) => {
        if (result) {
          $scope.saveLiabilities();
        }
      });
  };

  $scope.listLiabilitiesReady = (list) => {
    $scope.Model.financeProfileList.liabilities = list;
  };

  $scope.saveLiabilities = $mdUtil.debounce(() => {
    $scope.saveContact({ liabilities: $scope.Model.currentContact.liabilities });
  }, 1500);

  /*
   * Contact asset commitment schedules
   * --------------------------------------------------------------------------------
   */
  $scope.assetCommitmentScheduleEdit = ($event, currentAssetCommitment) => {
    $event.stopPropagation();
    const assetCommitment = currentAssetCommitment
      ? AssetFinanceAssetCommitment.build(currentAssetCommitment)
      : AssetFinanceAssetCommitment.blank();
    const isEdit = currentAssetCommitment !== undefined;

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          assetCommitments:
            $scope.Model.currentContact.assetCommitmentSchedules[0]?.assetCommitments,
          contact: $scope.Model.currentContact,
          lenders: _.chain($scope.Model.availableLendersPerCountry)
            .filter((l) => l.type.indexOf('ASSET_FINANCE') > -1)
            .sortNatural('name')
            .sortNatural('group')
            .value(),
          availableTermInMonths: helperService.getAvailableTermInMonths({
            isRegular: true
          }),
          availableProductTypes: assetFinanceService.getAvailableProductTypes({
            isCommercial: true
          })
        },
        template: templateAssetCommitment,
        controllerAs: '$ctrl',
        controller(
          assetCommitments,
          contact,
          lenders,
          availableTermInMonths,
          availableProductTypes
        ) {
          const ctrl = this;
          ctrl.assetCommitments = assetCommitments;
          ctrl.assetCommitment = assetCommitment;
          ctrl.isEdit = isEdit;

          ctrl.contact = contact;
          ctrl.lenders = lenders;
          ctrl.organizationCountry = helperService.getOrganizationCountry();
          ctrl.availableTermInMonths = availableTermInMonths;
          ctrl.availableProductTypes = availableProductTypes;
          ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
          ctrl.currentCurrency = $rootScope.CurrentCurrency();
          dateTimeService.getSet(
            ctrl,
            ctrl.assetCommitment,
            'dateTakenOut',
            'getSetDateTakenOut'
          );

          ctrl.isLenderSelected = ({ lenderAbbr }) => {
            if (lenderAbbr) {
              return _.find(ctrl.lenders, (l) => l.abbr.toLowerCase() === lenderAbbr);
            }
            return true;
          };

          ctrl.confirm = () => {
            $mdDialog.hide({
              isEdit: ctrl.isEdit,
              assetCommitment: ctrl.assetCommitment
            });
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        if (!result.isEdit) {
          if (!$scope.Model.currentContact?.assetCommitmentSchedules?.length) {
            $scope.Model.currentContact.assetCommitmentSchedules.push(
              AssetFinanceAssetCommitmentSchedule.blank()
            );
          }
          $scope.Model.currentContact.assetCommitmentSchedules[0].assetCommitments.push(
            result.assetCommitment
          );
        } else {
          const idx = _.findIndex(
            $scope.Model.currentContact?.assetCommitmentSchedules[0]?.assetCommitments || [],
            (a) => a?.id === result.assetCommitment?.id
          );
          if (idx > -1) {
            $scope.Model.currentContact.assetCommitmentSchedules[0].assetCommitments.splice(
              idx,
              1
            );
            $scope.Model.currentContact.assetCommitmentSchedules[0].assetCommitments.splice(
              idx,
              0,
              result.assetCommitment
            );
          }
        }
        $scope.saveAssetCommitmentSchedules();
      });
  };

  $scope.assetCommitmentScheduleDelete = ($event, assetCommitment) => {
    $event.stopPropagation();
    const idx = _.findIndex(
      $scope.Model.currentContact.assetCommitmentSchedules[0]?.assetCommitments,
      (a) => a?.id === assetCommitment?.id
    );
    if (idx > -1) {
      helperService
        .deleteItem(
          $scope.Model.currentContact.assetCommitmentSchedules[0]?.assetCommitments,
          assetCommitment,
          'Asset commitment schedule',
          `row #${idx + 1}`
        )
        .then((result) => {
          if (result) {
            $scope.saveAssetCommitmentSchedules();
          }
        });
    }
  };

  $scope.listAssetCommitmentSchedulesReady = (list) => {
    $scope.Model.financeProfileList.assetCommitmentSchedules = list;
  };

  $scope.saveAssetCommitmentSchedules = $mdUtil.debounce(() => {
    $scope.saveContact({
      assetCommitmentSchedules: $scope.Model.currentContact.assetCommitmentSchedules
    });
  }, 1500);

  /*
   * Contact insurances
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentContact.assets
    });
  };

  $scope.canSeeInsuranceType = (insuranceType) =>
    insurancesService.canSeeInsuranceType(insuranceType);

  $scope.insuranceEdit = ($event, insuranceType, currentInsurance) => {
    $event.stopPropagation();
    const contact = $scope.Model.currentContact;
    const insurance = currentInsurance
      ? Insurance.build(currentInsurance)
      : Insurance.blank(insuranceType);
    const isEdit = currentInsurance !== undefined;
    if (!isEdit) {
      insurance.idContacts.push($scope.Model.currentContact.id);
    }

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {},
        template: templateInsuranceEdit,
        controllerAs: '$ctrl',
        controller() {
          const ctrl = this;
          ctrl.insurance = insurance;
          ctrl.isEdit = isEdit;
          ctrl.contact = contact;

          ctrl.confirm = () => {
            $mdDialog.hide({ isEdit: ctrl.isEdit, insurance: ctrl.insurance });
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        const ins = result.insurance;
        delete ins.insuranceType.isDisabled;
        if (result.isEdit) {
          const idx = $scope.Model.currentContact.insurances.findIndex((a) => a.id === ins.id);
          if (idx > -1) {
            $scope.Model.currentContact.insurances.splice(idx, 1);
            $scope.Model.currentContact.insurances.splice(idx, 0, ins);
          }
        } else {
          if (
            !ins.isInsuranceHomeContents() &&
            !ins.isInsuranceVehicle() &&
            !ins.isInsuranceMotorWarrantyProducts()
          ) {
            ins.idContacts.push($scope.Model.currentContact.id);
          }
          $scope.Model.currentContact.insurances.push(ins);
        }
        $scope.saveInsurances();
      });
  };

  $scope.insuranceDelete = ($event, insurance) => {
    $event.stopPropagation();
    helperService.deleteItem(
      $scope.Model.currentContact.insurances,
      insurance,
      'Insurance',
      insurance.getName(),
      $scope.saveInsurances
    );
  };

  $scope.listInsurancesReady = (list) => {
    $scope.Model.financeProfileList.insurances = list;
  };

  $scope.saveInsurances = $mdUtil.debounce(() => {
    $scope.saveContact({ insurances: $scope.Model.currentContact.insurances });
  }, 1500);

  /*
   * Contact view ~ Integration
   * --------------------------------------------------------------------------------
   */
  $scope.diversificationActionFinished = (integration, result) => {
    if (integration === 'REFERRAL' && result?.status) {
      notesService.clearCache();
      loadNotes();
    }
  };

  /*
   * Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = ($event) => {
    $event.stopPropagation();
    navigationService.goToPreviousState();
  };

  /*
   * Save Contact
   * --------------------------------------------------------------------------------
   */
  $scope.saveContact = (data) => {
    const contact = data;
    contact.id = $scope.Model.currentContact.id;
    contact.isCompany = $scope.Model.currentContact.isCompany;
    contact.person = { information: { firstName: '', familyName: '' } };
    contact.company = { information: { name: '' } };
    contact.person.information.firstName =
      $scope.Model.currentContact.person.information.firstName;
    contact.person.information.familyName =
      $scope.Model.currentContact.person.information.familyName;
    contact.company.information.name = $scope.Model.currentContact.company.information.name;
    contactService.updateContact(contact).then((result) => {
      contactsService.clearCache();
      if (result.status) {
        uiService.toast({
          text: {
            p1: 'Contact',
            p2: $scope.Model.currentContact.getName(),
            p3: 'has been updated'
          },
          warn: false
        });
      }
    });
  };
};
